import React from 'react';
import './Testimonials.css';

const testimonialsData = [
  {
    id: 1,
    text: "I recently completed a five-day at-home physiotherapy session with therapist Chandana, and I'm happy with the results. Chandana was professional, punctual, and tailored each session to my needs, significantly improving my mobility and reducing pain.",
    author: "Patient Review"
  },
  {
    id: 2,
    text: "I had back pain for last few weeks and booked physiotherapy service from Physero. Jyotish from Physero was assigned to me and did a fabulous job. Instead of just relying on machines, the exercises which he made me do, gave me immediate relief and within a week, I became normal.",
    author: "Patient Review"
  },
  {
    id: 3,
    text: "My mother had a total knee replacement surgery for both legs, Salama was her physiotherapist and she was very regular and ensured all the exercise are properly done by my mother. Overall a good experience.",
    author: "Patient Review"
  }
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="testimonials">
      <div className="container">
        <div className="section-header">
          <h2>What Our Patients Think Of Us?</h2>
          <p>Hear It From Them!</p>
        </div>

        <div className="testimonials-grid">
          {testimonialsData.map(testimonial => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="testimonial-content">
                <p>"{testimonial.text}"</p>
              </div>
              <div className="testimonial-author">
                <span>{testimonial.author}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;